import '../../css/home/collection_list_7.scss';

$(function() {

    //theme_bg_container
    gsap.timeline({
        scrollTrigger: {
            trigger: '.theme_bg_container',
            start: "top top",
            end: "+=200%",
            pin: true,
        }
    })


    const timeline1 = gsap.timeline({ paused: true })
        .from(".theme_bg_container", { duration: 1.2, opacity: 0, ease: 'power0.out' })
        .from(".theme_title", { duration: 1, opacity: 0, y: 10, ease: 'power0.out' }, '-=.8')
        .from(".theme_description", { duration: 1, opacity: 0, y: 20, ease: 'quart.out' }, '-=.3')

    imagesLoaded("html, body", function() {
        timeline1.play();
    });

    //row_1
    if ($('.row_1').length > 0) {
        gsap.timeline({ scrollTrigger: { trigger: '.row_1', start: "top 70%", toggleActions: "play none none none", } })
            .from(".row_1 .collection_pic", {
                duration: .6,
                opacity: 0,
                x: -150,
                stagger: {
                    each: 0.15,
                    ease: "quart.out",
                }
            })
            .from(".row_1 .collection_caption", {
                duration: .6,
                opacity: 0,
                x: 20,
                stagger: {
                    each: 0.15,
                    ease: "quart.out",
                }
            }, '-=.45')
    }


    //row_2
    if ($('.row_2').length > 0) {
        gsap.timeline({ scrollTrigger: { trigger: '.row_2', start: "top 70%", toggleActions: "play none none none", } })
            .from(".row_2 .collection_pic", {
                duration: .6,
                opacity: 0,
                x: -150,
                stagger: {
                    each: 0.15,
                    ease: "quart.out",
                }
            })
            .from(".row_2 .collection_caption", {
                duration: .6,
                opacity: 0,
                x: 20,
                stagger: {
                    each: 0.15,
                    ease: "quart.out",
                }
            }, '-=.45')
    }

    //row_3
    if ($('.row_3').length > 0) {
        gsap.timeline({ scrollTrigger: { trigger: '.row_3', start: "top 70%", toggleActions: "play none none none", } })
            .from(".row_3 .collection_pic", {
                duration: .6,
                opacity: 0,
                x: -150,
                stagger: {
                    each: 0.15,
                    ease: "quart.out",
                }
            })
            .from(".row_3 .collection_caption", {
                duration: .6,
                opacity: 0,
                x: 20,
                stagger: {
                    each: 0.15,
                    ease: "quart.out",
                }
            }, '-=.45')
    }

    //theme_items
    gsap.timeline({ scrollTrigger: { trigger: '.theme_items', start: "top 70%", toggleActions: "play none none none", } })
        .from(".col_item", {
            duration: 1,
            opacity: 0,
            y: 200,
            stagger: 0.13,
            ease: "quart.out",
        })
});